module.exports = __webpack_public_path__ + "img/cloud-download.6a81ca3a.svg";